import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function SponsorTeamMemberTitleField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (newValue === '') {
      setError('Title cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Title'
          id='title'
          aria-describedby='title-helper-text'
          onChange={handleChange}
          error={Boolean(error || value === '')}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='title-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='title-helper-text'>
            Enter the team member's title
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
